export default [
    {
        path: "/",
        name: "home",
        meta: {
            authRequired: true,
            translate: (t) => {
                return t('menu.home').ucFirst();
            },
        },
        component: () => import("../views/layouts/vertical.vue"),
        children: [
            {
                path: 'doctor/drafts',
                name: 'doctor-drafts',
                meta: {
                    ability: 'therapy-drafts.review',
                    translate: (t) => {
                        return t('menu.drafts').ucFirst();
                    },
                },
                component: () => import('../views/helpers/grouper/grouper.vue'),
                redirect: {name: 'doctor-drafts-list'},
                children: [
                    {
                        path: '',
                        name: 'doctor-drafts-list',
                        meta: {
                            ability: 'therapy-drafts.review',
                            translate: (t) => {
                                return t('menu.drafts').ucFirst();
                            },
                        },
                        component: () => import('../views/pages/doctor/drafts/index.vue')
                    },
                    {
                        path: ':id',
                        name: 'doctor-draft-show',
                        meta: {
                            ability: 'therapy-drafts.review',
                            translate: (t) => {
                                return t('pages.doctor.drafts.review_title').ucFirst();
                            },
                        },
                        component: () => import('../views/pages/doctor/drafts/show.vue')
                    },
                ]
            },
            {
                path: 'doctor/patients',
                name: 'doctor-patients',
                meta: {
                    ability: 'therapies.create-medical',
                    translate: (t) => {
                        return t('menu.my_patients').ucFirst();
                    },
                },
                component: () => import('../views/helpers/grouper/grouper.vue'),
                redirect: {name: 'doctor-patients-list'},
                children: [
                    {
                        path: '',
                        name: 'doctor-patients-list',
                        meta: {
                            ability: 'therapies.create-medical',
                            translate: (t) => {
                                return t('menu.my_patients').ucFirst();
                            },
                        },
                        component: () => import('../views/pages/doctor/patients/index.vue')
                    },
                    {
                        path: ':pseudonymId',
                        name: 'doctor-patient-show',
                        meta: {
                            ability: 'therapies.create-medical',
                            translate: (t) => {
                                return t('pages.doctor.patients.console_title').ucFirst();
                            },
                        },
                        component: () => import('../views/pages/doctor/patients/show.vue')
                    },
                ]
            },
            {
                path: 'admin/components',
                name: 'admin-components',
                meta: {
                    ability: 'components.create',
                    translate: (t) => {
                        return t('menu.components').ucFirst();
                    },
                },
                component: () => import('../views/helpers/grouper/grouper.vue'),
                redirect: {name: 'admin-components-list'},
                children: [
                    {
                        path: '',
                        name: 'admin-components-list',
                        meta: {
                            ability: 'components.create',
                            translate: (t) => {
                                return t('menu.components').ucFirst();
                            },
                        },
                        component: () => import('../views/pages/admin/components/index.vue')
                    },
                    {
                        path: ':id',
                        name: 'admin-component-show',
                        meta: {
                            ability: 'components.create',
                            translate: (t) => {
                                return t('actions.details').ucFirst();
                            },
                        },
                        component: () => import('../views/pages/admin/components/show.vue')
                    },
                ]
            },
            {
                path: 'admin/templates',
                name: 'admin-templates',
                meta: {
                    ability: 'therapy-templates.create',
                    translate: (t) => {
                        return t('menu.templates').ucFirst();
                    },
                },
                component: () => import('../views/helpers/grouper/grouper.vue'),
                redirect: {name: 'admin-templates-list'},
                children: [
                    {
                        path: '',
                        name: 'admin-templates-list',
                        meta: {
                            ability: 'therapy-templates.create',
                            translate: (t) => {
                                return t('menu.templates').ucFirst();
                            },
                        },
                        component: () => import('../views/pages/admin/templates/index.vue')
                    },
                    {
                        path: ':id',
                        name: 'admin-template-show',
                        meta: {
                            ability: 'therapy-templates.create',
                            translate: (t) => {
                                return t('actions.details').ucFirst();
                            },
                        },
                        component: () => import('../views/pages/admin/templates/show.vue')
                    },
                ]
            },
            {
                path: 'admin/medicines',
                name: 'admin-medicines',
                meta: {
                    ability: 'medicines.create',
                    translate: (t) => {
                        return t('menu.medicines').ucFirst();
                    },
                },
                component: () => import('../views/helpers/grouper/grouper.vue'),
                redirect: {name: 'admin-medicines-list'},
                children: [
                    {
                        path: '',
                        name: 'admin-medicines-list',
                        meta: {
                            ability: 'medicines.create',
                            translate: (t) => {
                                return t('menu.medicines').ucFirst();
                            },
                        },
                        component: () => import('../views/pages/admin/medicines/index.vue')
                    },
                    {
                        path: ':id',
                        name: 'admin-medicine-show',
                        meta: {
                            ability: 'medicines.create',
                            translate: (t) => {
                                return t('actions.details').ucFirst();
                            },
                        },
                        component: () => import('../views/pages/admin/medicines/show.vue')
                    },
                ]
            },
            {
                path: 'admin/assignments',
                name: 'admin-assignments',
                meta: {
                    ability: 'assignments.create',
                    translate: (t) => {
                        return t('menu.assignments').ucFirst();
                    },
                },
                component: () => import('../views/pages/admin/assignments.vue')
            },
            {
                path: 'admin/users',
                name: 'admin-users',
                meta: {
                    ability: 'users.view',
                    translate: (t) => {
                        return t('details.user.menu').ucFirst();
                    },
                },
                component: () => import('../views/helpers/grouper/grouper.vue'),
                redirect: {name: 'admin-users-list'},
                children: [
                    {
                        path: '',
                        name: 'admin-users-list',
                        meta: {
                            ability: 'users.view',
                            translate: (t) => {
                                return t('details.user.menu').ucFirst();
                            },
                        },
                        component: () => import('../views/pages/admin/users/index.vue')
                    },
                    {
                        path: ':pseudonymId',
                        name: 'admin-user-show',
                        meta: {
                            ability: 'users.view',
                            translate: (t) => {
                                return t('details.user.detail_title').ucFirst();
                            },
                        },
                        component: () => import('../views/pages/admin/users/show.vue')
                    },
                ]
            },
            {
                path: 'doctor/therapies/:id',
                name: 'doctor-therapy-show',
                meta: {
                    ability: 'therapies.view',
                    translate: (t) => {
                        return t('details.therapy.detail_title').ucFirst();
                    },
                },
                component: () => import('../views/pages/doctor/therapies/show.vue')
            },
            {
                path: 'admin/audit-events',
                name: 'admin-audit-events',
                meta: {
                    ability: 'audit-events.view',
                    translate: (t) => {
                        return t('menu.audit_events').ucFirst();
                    },
                },
                component: () => import('../views/pages/admin/audit-events.vue')
            },
            {
                path: 'admin/statistics',
                name: 'admin-statistics',
                meta: {
                    ability: 'statistics.view',
                    translate: (t) => {
                        return t('menu.statistics').ucFirst();
                    },
                },
                component: () => import('../views/pages/admin/statistics.vue')
            },
        ],
    },
    {
        path: "/login",
        name: "login",
        component: () => import("../views/pages/account/login"),
    },
    {
        path: "/error/404-basic",
        name: "error-404-basic",
        component: () => import("../views/pages/errors/404-basic"),
    },
    {
        path: "/error/404-cover",
        name: "error-404-cover",
        component: () => import("../views/pages/errors/404-cover"),
    },
    {
        path: "/error/500-basic",
        name: "error-500-basic",
        component: () => import("../views/pages/errors/500-basic"),
    },
    {
        path: "/error/500-cover",
        name: "error-500-cover",
        component: () => import("../views/pages/errors/500-cover"),
    },
    {
        path: "/:pathMatch(.*)*",
        name: "not-found",
        redirect: {name: "error-404-basic"},
    },
];
